
import ApiNode from "./ApiNode";

export default {
    // Driver CRUD Operations
    createDriver(payload, config) {
        return ApiNode().post("main-master/driver/create", payload, config);
    },

    getAllDrivers(params, config) {
        return ApiNode().get("main-master/driver/all", { params }, config);
    },

    getDriverById(driverId, config) {
        return ApiNode().get(`main-master/driver/${driverId}`, config);
    },

    // Get detailed driver information
    getDriverInfo(payload, config) {
        return ApiNode().post(`main-master/driver/driver-info`, payload, config);
    },

    updateDriver(driverId, payload, config) {
        return ApiNode().put(`main-master/driver/${driverId}`, payload, config);
    },

    deleteDriver(driverId, config) {
        return ApiNode().delete(`main-master/driver/${driverId}`, config);
    },

    // Driver Status Management
    updateDriverStatus(payload, config) {
        return ApiNode().put("main-master/driver/status/update", payload, config);
    },

    // Import/Export Operations
    importDrivers(payload, config) {
        return ApiNode().post("main-master/driver/import", payload, config);
    },

    exportDrivers(params, config) {
        return ApiNode().get("main-master/driver/export/excel", { 
            params, 
            responseType: 'blob',
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/services/DriverService.js